// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7736 ? "9adb6eba" : chunkId) + "." + {"5297":"973f81cd8b61daa0","5302":"b29c9b584fc9859f","7736":"cee6c1be8d0d9652"}[chunkId] + ".js";
};